import React from 'react';
import Alert from 'react-bootstrap/Alert';
import Table from 'react-bootstrap/Table';

import BaseWidget from '../base-widget/BaseWidget';
import {LocaleDate} from "../../../common/Date";
import Loader from "../../loader/Loader";
import {FIELD_TO_TITLE_MAP} from "../../../utils/soml-utils";
import {SchemaProps} from "../../../types/Schema";

type SchemaMetadata = Pick<SchemaProps, 'id' | 'label' | 'creator' | 'created' | 'updated' | 'versionInfo'>;

type SchemaMetadataWidgetProps = {
  schema?: string;
  loading?: boolean;
  error?: any;
}

class SchemaMetadataWidget extends React.Component<SchemaMetadataWidgetProps> {

  render() {
    const metadata = this.props.schema && SchemaMetadataWidget.getSchemaMetadata(this.props.schema);
    return (
      <BaseWidget title="Schema Metadata" className="SchemaMetadataWidget">
        {
          this.props.loading && <Loader size='lg' block={true}/>
        }
        {
          !this.props.loading && metadata && <SchemaProperties metadata={metadata}/>
        }
        {
          this.props.error && <Alert variant="danger">{this.props.error}</Alert>
        }
      </BaseWidget>
    );
  }

  private static getSchemaMetadata(schemaYaml: any): SchemaMetadata {
    return {
      id: schemaYaml.id,
      label: schemaYaml.label,
      creator: schemaYaml.creator || '',
      created: schemaYaml.created || '',
      updated: schemaYaml.updated || '',
      versionInfo: schemaYaml.versionInfo || null
    };
  }
}

function SchemaProperties(props: { metadata: SchemaMetadata }) {
  return <Table size="sm" borderless hover>
    <tbody>
    <tr>
      <td>{FIELD_TO_TITLE_MAP.id}</td>
      <td className="schemaId text-break">{props.metadata.id}</td>
    </tr>
    <tr>
      <td>{FIELD_TO_TITLE_MAP.label}</td>
      <td className="label">{props.metadata.label}</td>
    </tr>
    <tr>
      <td>{FIELD_TO_TITLE_MAP.creator}</td>
      <td className="creator">{props.metadata.creator}</td>
    </tr>
    <tr>
      <td>{FIELD_TO_TITLE_MAP.created}</td>
      <td className="created"><LocaleDate date={props.metadata.created}/></td>
    </tr>
    <tr>
      <td>{FIELD_TO_TITLE_MAP.updated}</td>
      <td className="updated"><LocaleDate date={props.metadata.updated}/></td>
    </tr>
    <tr>
      <td>{FIELD_TO_TITLE_MAP.versionInfo}</td>
      <td className="versionInfo">{props.metadata.versionInfo}</td>
    </tr>
    </tbody>
  </Table>
}

export default SchemaMetadataWidget;
